import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'

import patchnote from '../../data/Patchnotes/patchnote.json'

import { UIContext } from '../../contexts/ui'

import './Menu.scss'

function Menu(props) {
	const { Theme } = useContext(UIContext)
	let location = 'simulator'
	switch (useLocation().pathname) {
		case '/expscaler':
			location = 'expscaler'
			break
		case '/refine':
			location = 'refine'
			break
		case '/news':
			location = 'news'
			break
		case '/contact':
			location = 'contact'
			break
		case '/about':
			location = 'about'
			break
		case '/index':
		default:
			location = 'simulator'
			break
	}
	return (
		<aside
			className={
				'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion Theme' +
				Theme
			}
			id='accordionSidebar'
		>
			<a
				className='sidebar-brand d-flex align-items-center justify-content-center'
				href='index'
			>
				<div className='sidebar-brand-icon '>
					<img
						className='Logo'
						src='.\Images\Logo\angeling.gif'
						alt='Logo'
					/>
				</div>
				<div className={'sidebar-brand-text mx-3 Theme' + Theme}>
					Ragnarok Prime Simulator
				</div>
			</a>
			{/* <!-- Divider --> */}
			<hr className='sidebar-divider' />
			{/* <!-- Nav Item - Dashboard --> */}
			<span id='menu'>
				<div className={'sidebar-heading Theme' + Theme}>
					Last update : {patchnote[0].date} <br />
					{location.pathname}
				</div>
				<li
					className={
						'nav-item ' + (location === 'simulator' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='index'
					>
						<i
							className='fas fa-fw fa-calculator'
							aria-hidden='true'
						></i>
						<span>
							Simulator
							<br />
						</span>
					</a>
				</li>
				<li
					className={
						'nav-item ' + (location === 'expscaler' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='expscaler'
					>
						<i
							className='fas fa-fw fa-chart-area'
							aria-hidden='true'
						></i>
						<span>EXP Scaler</span>
					</a>
				</li>
				<li
					className={
						'nav-item ' + (location === 'refine' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='refine'
					>
						<i
							className='fas fa-fw fa-hammer'
							aria-hidden='true'
						></i>
						<span>
							Refine
							<br />
						</span>
					</a>
				</li>
				<li
					className={
						'nav-item ' + (location === 'news' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='news'
					>
						<i
							className='fas fa-fw fa-wrench'
							aria-hidden='true'
						></i>
						<span>
							Patch Notes
							<br />
						</span>
					</a>
				</li>
				<li className='nav-item'>
					<span className={'nav-link nav-link Theme' + Theme}>
						<i
							className='fas fa-fw fa-calendar-days'
							aria-hidden='true'
						></i>
						<span className='CentralLabCode'>
							Central Lab Code: 15
							<table className='CentralLabCodeTable'>
								<tbody>
									<tr>
										<td className='S1'>S1</td>
										<td className='S2'>S2</td>
										<td className='S3'>S3</td>
										<td className='S4'>S4</td>
										<td className='S5'>S5</td>
										<td className='S6'>S6</td>
										<td className='S7'>S7</td>
										<td className='S8'>S8</td>
									</tr>
									<tr>
										<td className={'Theme' + Theme}>-</td>
										<td className={'Theme' + Theme}>-</td>
										<td className={'Theme' + Theme}>-</td>
										<td className={'Theme' + Theme}>-</td>
										<td className={'Theme' + Theme}>ON</td>
										<td className={'Theme' + Theme}>ON</td>
										<td className={'Theme' + Theme}>ON</td>
										<td className={'Theme' + Theme}>ON</td>
									</tr>
								</tbody>
							</table>
						</span>
					</span>
				</li>
				{/* <!-- Divider --> */}
				<hr className='sidebar-divider' />
				{/* <!-- Heading --> */}
				<div
					className={'sidebar-heading sidebar-heading Theme' + Theme}
				>
					Others
				</div>
				<li
					className={
						'nav-item ' + (location === 'contact' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='contact'
					>
						<i
							className='fas fa-fw fa-envelope'
							aria-hidden='true'
						></i>
						<span>Contact</span>
					</a>
				</li>
				<li className='nav-item'>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='https://discord.gg/Q3U5zEMQg3'
					>
						<i
							className='fa-brands fa-discord'
							aria-hidden='true'
						></i>
						<span>Discord</span>
					</a>
				</li>
				<li className='nav-item'>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='https://github.com/Kordasauter/roprime-simulator.com'
					>
						<i
							className='fa-brands fa-github'
							aria-hidden='true'
						></i>
						<span>GitHub</span>
					</a>
				</li>
				<li className='nav-item'>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='https://streamlabs.com/kord_en_live/tip'
					>
						<i
							className='fa-brands fa-paypal'
							aria-hidden='true'
						></i>
						<span>Donate</span>
					</a>
				</li>
				<li
					className={
						'nav-item ' + (location === 'about' ? 'active' : '')
					}
				>
					<a
						className={'nav-link nav-link Theme' + Theme}
						href='about'
					>
						<i
							className='fas fa-fw fa-question'
							aria-hidden='true'
						></i>
						<span>About</span>
					</a>
				</li>
			</span>
		</aside>
	)
}

export default Menu
